module.exports = __webpack_public_path__ + "assets/img/icon-bottom-1.bf3a17e6.jpg";